/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ReactNode } from 'react';
import { useDrag } from 'react-dnd';
import { Identifiable } from '../../../../Utils/Interfaces/Identifiable';
import { DraggableProps } from './DraggableProps';

export const Draggable = <T extends Identifiable>({
  type,
  children,
  onItemRequest
}: DraggableProps<T> & { children?: ReactNode }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type,
    item: onItemRequest(),
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging()
    })
  }));

  return (
    <div ref={drag} style={{ opacity: isDragging ? 0.3 : 1 }}>
      {children}
    </div>
  );
};
